import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import ConfigurationMarkdown from "./ConfigurationMarkdown.vue";
import { FontAwesomeIcon, FontAwesomeLayers } from "@fortawesome/vue-fontawesome";
import "./badgeIcons";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ObjectStoreBadge',
    props: {
        badge: null,
        size: { default: "3x" },
        moreOnHover: { type: Boolean, default: true }
    },
    setup(__props) {
        const props = __props;
        const MESSAGES = {
            restricted: "This dataset is stored on storage restricted to a single user. It can not be shared, published, or added to Galaxy data libraries.",
            user_defined: "This storage was user defined and is not managed by the Galaxy administrator.",
            quota: "A Galaxy quota is enabled for this object store.",
            no_quota: "No Galaxy quota is enabled for this object store.",
            faster: "This storage has been marked as a faster option by the Galaxy administrator.",
            slower: "This storage has been marked as a slower option by the Galaxy administrator.",
            short_term: "This storage has been marked routinely purged by the Galaxy administrator.",
            backed_up: "This storage has been marked as backed up by the Galaxy administrator.",
            not_backed_up: "This storage has been marked as not backed up by the Galaxy administrator.",
            more_secure: "This storage has been marked as more secure by the Galaxy administrator. The Galaxy web application doesn't make any additional promises regarding security for this storage.",
            less_secure: "This storage has been marked as less secure by the Galaxy administrator. The Galaxy web application doesn't make any additional promises regarding security for this storage.",
            more_stable: "This storage has been marked as more stable by the Galaxy administrator - expect jobs to fail less because of storage issues for this storage.",
            less_stable: "This storage has been marked as less stable by the Galaxy administrator - expect jobs to fail more because of storage issues for this storage.",
            cloud: "This is cloud storage.",
        };
        const advantage = "storage-advantage";
        const disadvantage = "storage-disadvantage";
        const neutral = "storage-neutral";
        const transparent = "reduced-opacity";
        const stockMessage = computed(() => {
            return MESSAGES[props.badge.type];
        });
        const layerClasses = computed(() => {
            return [`fa-${props.size}`, "fa-fw"];
        });
        const badgeType = computed(() => {
            return props.badge.type;
        });
        const shrink = computed(() => {
            return { transform: "shrink-6" };
        });
        const message = computed(() => {
            return props.badge.message;
        });
        return { __sfc: true, MESSAGES, props, advantage, disadvantage, neutral, transparent, stockMessage, layerClasses, badgeType, shrink, message, ConfigurationMarkdown, FontAwesomeIcon, FontAwesomeLayers };
    }
});
